import { render, staticRenderFns } from "./ClinicContacts.vue?vue&type=template&id=35b5596d&scoped=true&"
import script from "./ClinicContacts.vue?vue&type=script&lang=js&"
export * from "./ClinicContacts.vue?vue&type=script&lang=js&"
import style0 from "./ClinicContacts.vue?vue&type=style&index=0&id=35b5596d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b5596d",
  null
  
)

export default component.exports